import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OrderIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Order",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.53 7.27c-.08-.82-.77-1.46-1.6-1.46h-3.88v-.53c0-2.59-2.12-4.71-4.72-4.71h-.8c-2.6 0-4.72 2.12-4.72 4.71v.53H7c-.83 0-1.53.63-1.61 1.45L3.67 25.11a3.163 3.163 0 0 0 3.17 3.47l18.22-.14c1.85-.02 3.3-1.62 3.12-3.47zM12.79 5.28c0-1.5 1.22-2.72 2.73-2.72h.8c1.5 0 2.73 1.22 2.73 2.72v.53h-6.27v-.53Zm9.55 8.32-6.38 7.62c-.18.22-.45.35-.73.36h-.03c-.27 0-.54-.11-.72-.31l-3.9-4.16a.976.976 0 0 1 .05-1.4.993.993 0 0 1 1.4.05l3.13 3.34 5.66-6.76c.35-.42.98-.48 1.4-.12.42.35.48.98.12 1.4Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M22 29.29H10.57c-3.15 0-5.71-2.56-5.71-5.71V8.72c0-.63.51-1.14 1.14-1.14h20.57c.63 0 1.14.51 1.14 1.14v14.86c0 3.15-2.56 5.71-5.71 5.71M7.14 9.86v13.71c0 1.89 1.54 3.43 3.43 3.43H22c1.89 0 3.43-1.54 3.43-3.43V9.86z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.86 9.86c-.63 0-1.14-.51-1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14h-4.57c-.63 0-1.14.51-1.14 1.14v3.43a1.14 1.14 0 1 1-2.28 0V5.29c0-1.89 1.54-3.43 3.43-3.43h4.57c1.89 0 3.43 1.54 3.43 3.43v3.43c0 .63-.51 1.14-1.14 1.14ZM15.14 22.43c-.29 0-.58-.11-.81-.33l-2.29-2.29a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l1.48 1.48 4.91-4.91a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-5.71 5.71c-.22.22-.52.33-.81.33Z"
      })]
    })
  }));
};